module.exports = __webpack_public_path__ + "img/00.126e912b.png";